"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailType = void 0;
var EmailType;
(function (EmailType) {
    EmailType["AccountCreated"] = "account:created";
    EmailType["OrderCreated"] = "order:created";
    EmailType["OrderCompleted"] = "order:completed";
    EmailType["OrderConfirmed"] = "order:confirmed";
    EmailType["OrderCanceled"] = "order:canceled";
    EmailType["Reminder"] = "reminder";
    EmailType["PasswordReset"] = "auth:passwordreset";
    EmailType["Unrecognized"] = "unrecognized";
})(EmailType || (exports.EmailType = EmailType = {}));
